<template>

  <!-- 敬请期待 -->

  <div class="wrapper">

    <div class="container">
      <div class="success-icon">
        <img src="../../assets/1.png" alt="" srcset="">
      </div>
      <div class="success-info" v-if="register == 1">
        <!-- <span class="success-info-sign">￥</span>
        <span class="success-info-num">{{price | filterNum}}</span>
        <span class="success-info-exact">.{{price | filterNum(1)}}</span> -->
      </div>
      <div class="success-title" :class="{register:this.register != 1}">{{$t('comingSoon')}}</div>

      <!-- <div class="success-tip">支付失败原因：{{info}}</div>
      <div class="back-app" @click="backApp">{{backinfo}}</div> -->
    </div>

  </div>

</template>

<script>

export default {

  data () {

    return {
      register: 1,
      tipTitle: "即将上线，敬请期待"
    }

  },

  created () {
    window.document.title = this.$t('comingSoonTitel');
  },

  methods: {

    // 支付失败，返回app
    backApp (type = 0) {
      let path = "payment_status";
      if (this.register != 1 && type == 1) {
        path = "ticket_back";
      } else if (this.register != 1 && type != 1) {
        path = "ticket_next";
      }
      window.location.href = this.appName + "://eastfair";
      // this.hrefApp({ 
      //   path: path,
      //   routerId: 'failure'
      // });

    }

  }

}

</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;

  min-height: 100vh;

  flex-direction: column;
}

.container {
  display: flex;

  align-items: center;

  flex-direction: column;

  background-color: #ffffff;

  flex: 1;

  height: 100%;

  padding-top: 116px;

  .success-icon {
    img {
      height: 130px;
      width: 130px;
    }
  }

  .success-info {
    display: flex;
    display: -webkit-box;
    margin-top: 16px;
    justify-content: flex-end;
    align-items: flex-end;
    font-size: 14px;
    line-height: 46px;
    color: #6e7580;
    .success-info-num {
      font-size: 32px;
    }
  }

  .success-title {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(229, 0, 56, 1);
  }

  .success-tip {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(169, 175, 184, 1);
    line-height: 30px;
    .my-card {
      color: #424242;
    }
  }
}

.back-app {
  display: flex;

  justify-content: center;

  align-items: center;

  flex-direction: row;

  position: absolute;

  padding: 10px 0;

  background: linear-gradient(
    120deg,
    rgba(96, 176, 255, 1) 0%,
    rgba(71, 145, 255, 1) 49%,
    rgba(68, 141, 255, 1) 100%
  );

  font-size: 18px;

  font-family: PingFangSC-Regular, PingFang SC;

  font-weight: 400;

  color: rgba(255, 255, 255, 1);

  width: 80%;

  bottom: 48px;
}

.register {
  margin-top: 20px;
}
</style>
